<template>
  <v-dialog :value="isOpenDialogExport" max-width="320" persistent>
    <v-card>
      <v-card-title class="px-8 py-4">
        <v-row dense>
          <v-col cols="12" class="d-flex justify-center">
            <span class="subtitle-2 font-weight-medium" style="color: #2661FF;">
              <b>
                {{ $t("downloads.dialog1.title") }}
              </b>
            </span>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="px-8 pt-4 pb-0">
        <v-row dense>
          <v-col v-if="this.moduleOptions.length > 1" cols="12">
            <v-select
              :items="moduleOptions"
              v-model="module"
              :label="$t('downloads.dialog1.module')"
              v-validate="'required'"
              :data-vv-name="$t('downloads.dialog1.module')"
              :error-messages="errors.collect($t('downloads.dialog1.module'))"
              dense
              outlined
              required
            />
          </v-col>
          <v-col v-if="module === 'Lead'" cols="12">
            <v-text-field
              v-model="email"
              :label="$t('downloads.dialog1.lead_email')"
              v-validate="'required'"
              :data-vv-name="$t('downloads.dialog1.lead_email')"
              :error-messages="
                errors.collect($t('downloads.dialog1.lead_email'))
              "
              dense
              outlined
              required
            />
          </v-col>
          <v-col cols="12">
            <v-select
              :items="fileTypes"
              v-model="fileType"
              :label="$t('downloads.dialog1.file_type')"
              v-validate="'required'"
              :data-vv-name="$t('downloads.dialog1.file_type')"
              :error-messages="
                errors.collect($t('downloads.dialog1.file_type'))
              "
              item-text="name"
              item-value="value"
              dense
              outlined
              required
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="px-8 pt-0 pb-4">
        <v-row dense>
          <v-col cols="6" class="d-flex justify-end">
            <v-btn
              @click="exportFile()"
              :loading="loading"
              color="#2661FF"
              small
              block
            >
              <span style="color: white">{{
                $t("downloads.dialog1.button_export")
              }}</span>
            </v-btn>
          </v-col>
          <v-col cols="6" class="d-flex justify-start">
            <v-btn
              @click="close()"
              :disabled="loading"
              color="#2661FF"
              outlined
              small
              block
            >
              {{ $t("general.cancel") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  name: "DialogExport",
  props: {
    state: {
      type: Number,
      required: false
    },
    organization_id: {
      type: Number,
      required: false
    },
    moduleOptions: {
      type: Array,
      required: true
    },
    startDate: {
      type: String,
      required: true,
      default: new Date()
    },
    endDate: {
      type: String,
      required: true,
      default: new Date()
    },
    filters: {
      type: Object,
      require: false,
      default: () => ({})
    }
  },
  data() {
    return {
      loading: false,
      fileType: null,
      module: null,
      email: null,
      fileTypes: [
        { name: "XLSX", value: "xlsx" },
        { name: "CSV", value: "csv" }
      ]
    };
  },
  computed: {
    ...mapGetters({
      isOpenDialogExport: "downloads/isOpenDialogExport"
    })
  },
  mounted() {
    if (this.moduleOptions.length === 1) {
      this.module = this.moduleOptions[0];
    }
  },
  methods: {
    ...mapActions({
      exportData: "downloads/exportData",
      exportDataLead: "downloads/exportDataLead"
    }),
    ...mapMutations({
      toggleDialogExport: "downloads/toggleDialogExport",
      toggleDialogMessage: "downloads/toggleDialogMessage"
    }),
    async exportFile() {
      const isValid = await this.$validator.validateAll();
      if (isValid) {
        this.submit();
      }
    },
    async submit() {
      this.loading = true;

      const { filters } = this;

      let res;
      if (this.module === "Lead") {
        res = await this.exportDataLead({
          type: this.fileType,
          email: this.email
        });
      } else if (this.module === "DRBSubscriptions") {
        res = await this.exportData({
          type: this.fileType,
          module: this.module,
          filename: this.module,
          is_admin: true,
          organization_id: this.organization_id ? this.organization_id : 1,
          start_time: this.startDate,
          end_time: this.endDate,
          filters: {
            ...filters,
            startTimeWithtimeZone: this.startDate,
            endTimeWithtimeZone: this.endDate,
            organizationId: this.organization_id,
          }
        });
      } else {
        res = await this.exportData({
          type: this.fileType,
          module: this.module,
          filename: this.module,
          is_admin: true,
          organization_id: this.organization_id ? this.organization_id : 1,
          start_time: this.startDate,
          end_time: this.endDate,
          filters: {
            ...filters,
            startTimeWithtimeZone: this.startDate,
            endTimeWithtimeZone: this.endDate,
            organizationId: this.organization_id
          }
        });
      }
      this.loading = false;
      if (res.success) {
        this.close();
        this.toggleDialogMessage(true);
      }
    },
    close() {
      this.toggleDialogExport(false);
      this.loading = false;
      this.fileType = null;
      this.email = null;
      this.$validator.reset();
    }
  }
};
</script>
